export default __webpack_public_path__ + "static/tabs-independent-do-dc830142184e66daca0065440a9e06862994a859e1fab0e0eb3d99ddf7c24398.png";